(function() {
  function initNav() {
    var hw = document.querySelector('.header-wrapper--transparent');
    if (!hw) return;
    function tick() {
      if (window.scrollY > 10) {
        hw.classList.add('sente-scrolled');
      } else {
        hw.classList.remove('sente-scrolled');
      }
    }
    tick();
    window.addEventListener('scroll', tick, { passive: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNav);
  } else {
    initNav();
  }
  setTimeout(initNav, 500);
})();
